/**
 * ********************************************************************
 * Favorites manager
 *  - takes care of the mechanism for liking/unliking houses
 * ********************************************************************
 */

var locale = $('html').attr('lang');  // site locale
var Translator = require('bazinga-translator');
var translations = require('./translations/' + locale + '.json');
Translator.fromJSON(translations);
var bootbox = require('bootbox');

module.exports = {

    storageItemName: 'favorite_houses',
    storageLimit: 20,

    getFavorites: function () {
        return JSON.parse(localStorage.getItem(this.storageItemName)) || [];
    },

    updateCounterIcon: function () {
        var list = this.getFavorites();

        if (list.length > 0) {
            $('.like-box-container:not(.house)').addClass('full');
        } else {
            $('.like-box-container:not(.house)').removeClass('full');
        }

        $('.like-box-likes').html(list.length);

    },

    addHouseToFavorites: function (slug) {
        var favHouses = this.getFavorites();

        if (favHouses.filter(function (e) {
                return e.slug == slug;
            }).length == 0) {
            if (favHouses.length >= this.storageLimit) {
                bootbox.alert(Translator.trans('warning_you_can_like_max_x_houses', {"limit": this.storageLimit}));
            } else {
                favHouses.push({
                    "slug": slug,
                    "created_at": Date().toString()
                });
                this.updateCounterIcon();
            }
        }

        localStorage.setItem(this.storageItemName, JSON.stringify(favHouses));
    },

    removeHouseFromFavorites: function (slug) {
        var favHouses = this.getFavorites();

        favHouses = favHouses.filter(function (e) {
            return e.slug != slug;
        });

        localStorage.setItem(this.storageItemName, JSON.stringify(favHouses));

        this.updateCounterIcon();

    },

    houseLiked: function (slug) {
        return this.getFavorites().filter(function (e) {
                return e.slug == slug;
            }).length > 0;
    }
};